import React, { useState, useEffect, useRef } from 'react';
import styles from '../AssignNumber/AssignNumber.module.css';
import HeaderBar from '../HeaderBar/HeaderBar';
import Modal2 from '../Modal2/Modal2';
import AnimatedButton from '../AnimatedButton/AnimatedButton';
import { useLocation, useNavigate } from 'react-router-dom';
import { createNumberOrder, deleteVoipNumber, fetchAgentDetailById, fetchAvailablePhoneNumberByCountry, getAgentById, updateAgent, API_BASE_URL } from '../../Store/apiStore';
import decodeToken from "../../lib/decodeToken";
import Loader2 from '../Loader2/Loader2';
import axios from 'axios';
import PopUp from '../Popup/Popup';
import { useDashboardStore } from '../../Store/agentZustandStore';
// India site (app.rexpt.in / dev-server / localhost) khareedti hai Vobiz se, jo
// sirf India ke numbers bechta hai; baaki sab Telnyx se, jiske paas sirf US/CA
// hain. Isliye country list aur API dono site ke hisaab se badalte hain.
import { usesVobiz, numberSearchLocation } from '../../utils/apiBackend';
import { createVobizNumberOrder, fetchAvailableVobizNumbers } from '../../Store/apiStore';

// Telnyx wali functions bilkul waise hi hain jaise pehle thi — unhe chhua nahi
// gaya, kyunki wahi live US/AppSumo flow chalati hain.
const searchNumbers = (...args) =>
    usesVobiz()
        ? fetchAvailableVobizNumbers(...args)
        : fetchAvailablePhoneNumberByCountry(...args);

const orderNumber = (...args) =>
    usesVobiz() ? createVobizNumberOrder(...args) : createNumberOrder(...args);
const AssignNumber = () => {
    const location = useLocation();
    const stateInputRef = useRef(null);
    const cityInputRef = useRef(null);
    const { agents, totalCalls, hasFetched, setDashboardData, setHasFetched } = useDashboardStore();
    const [stateNameFull, setStateNameFull] = useState('');
    const [open, setOpen] = useState(false);
    const [selectedLangCode, setSelectedLangCode] = useState('us');
    // Site ka default: India site pe IN, warna US. Hardcoded 'US' rehta to
    // India pe screen US par khulti aur Vobiz ke paas US ka stock hai hi nahi.
    const [countryCode, setCountryCode] = useState(usesVobiz() ? 'IN' : 'US');
    const [stateCode, setStateCode] = useState('');
    const [cityName, setCityName] = useState('');
    const [search, setSearch] = useState('');
    const [availableNumbers, setAvailableNumbers] = useState([]);
    const [selectedNumber, setSelectedNumber] = useState(null);
    const [isRotating, setIsRotating] = useState(false);
    const [isModalOpen, setModalOpen] = useState(false);
    const [loading, setLoading] = useState(false)
    const [agent_id, setAgent_id] = useState("")
    const [showPopup, setShowPopup] = useState(false);
    const [popupType, setPopupType] = useState(null);
    const [popupMessage, setPopupMessage] = useState("");
    const [voip_numbers, setVoip_numbers] = useState("")
    const debounceTimeoutRef = useRef(null);
    const requestVersion = useRef(0)
    const popupShownRef = useRef(false);
    const paygActivated = useRef(false);
    const token = localStorage.getItem("token")
    const decodeTokenData = decodeToken(token);
    const numberEditMode = location?.state?.numberEditMode || false;
    const navigate = useNavigate()
    // const languages = [
    //     {
    //         name: "English (US)",
    //         locale: "en-US",
    //         countryCode: "US",
    //         countryName: "United States",
    //         flag: "/images/en-US.png",
    //         percentage: "—",
    //         stats: "—",
    //     },
    //     {
    //         name: "French (Canada)",
    //         locale: "fr-CA",
    //         countryCode: "CA",
    //         countryName: "Canada",
    //         flag: "/images/fr-CA.png",
    //         percentage: "—",
    //         stats: "—",
    //     },
    //      {
    //         name: "French (Canada)",
    //         locale: "fr-CA",
    //         countryCode: "CA",
    //         countryName: "Canada",
    //         flag: "/images/fr-CA.png",
    //         percentage: "—",
    //         stats: "—",
    //     }
    // ];

    // Sirf wo countries jinme is site ka provider sach me number bech sakta hai.
    // Vobiz ke paas US/CA ka stock hai hi nahi aur Telnyx ke paas India ka — to
    // dono ek saath dikhana user ko aisi jagah chunne deta hai jahan se kabhi
    // koi number nahi milega, aur wo "No number available" jaisa dikhta hai.
    const languages = usesVobiz() ? [
        {
            name: "Hindi (India)",
            locale: "hi-IN",
            countryCode: "IN",
            countryName: "India",
            flag: "/images/hi-IN.png",
            percentage: "—",
            stats: "—",
        },
    ] : [
        {
            name: "English (US)",
            locale: "en-US",
            countryCode: "US",
            countryName: "United States",
            flag: "/images/en-US.png",
            percentage: "—",
            stats: "—",
        },
        {
            name: "French (Canada)",
            locale: "fr-CA",
            countryCode: "CA",
            countryName: "Canada",
            flag: "/images/fr-CA.png",
            percentage: "—",
            stats: "—",
        }
        // {
        //     name: "English (UK)",
        //     locale: "en-GB",
        //     countryCode: "GB",
        //     countryName: "United Kingdom",
        //     flag: "/images/en-GB.png",
        //     percentage: "—",
        //     stats: "—",
        // },
        // {
        //     name: "English (Australia)",
        //     locale: "en-AU",
        //     countryCode: "AU",
        //     countryName: "Australia",
        //     flag: "/images/en-AU.png",
        //     percentage: "—",
        //     stats: "—",
        // },
        // {
        //     name: "German (Germany)",
        //     locale: "de-DE",
        //     countryCode: "DE",
        //     countryName: "Germany",
        //     flag: "/images/de-DE.png",
        //     percentage: "—",
        //     stats: "—",
        // },
        // {
        //     name: "French (France)",
        //     locale: "fr-FR",
        //     countryCode: "FR",
        //     countryName: "France",
        //     flag: "/images/fr-FR.png",
        //     percentage: "—",
        //     stats: "—",
        // },
        // {
        //     name: "Spanish (Spain)",
        //     locale: "es-ES",
        //     countryCode: "ES",
        //     countryName: "Spain",
        //     flag: "/images/es-ES.png",
        //     percentage: "—",
        //     stats: "—",
        // },
        // {
        //     name: "Spanish (Mexico)",
        //     locale: "es-MX",
        //     countryCode: "MX",
        //     countryName: "Mexico",
        //     flag: "/images/es-MX.png",
        //     percentage: "—",
        //     stats: "—",
        // },
        // {
        //     name: "Portuguese (Brazil)",
        //     locale: "pt-BR",
        //     countryCode: "BR",
        //     countryName: "Brazil",
        //     flag: "/images/pt-BR.png",
        //     percentage: "—",
        //     stats: "—",
        // },
        // {
        //     name: "Italian (Italy)",
        //     locale: "it-IT",
        //     countryCode: "IT",
        //     countryName: "Italy",
        //     flag: "/images/it-IT.png",
        //     percentage: "—",
        //     stats: "—",
        // },
        // {
        //     name: "Dutch (Netherlands)",
        //     locale: "nl-NL",
        //     countryCode: "NL",
        //     countryName: "Netherlands",
        //     flag: "/images/nl-NL.png",
        //     percentage: "—",
        //     stats: "—",
        // },
        // {
        //     name: "Swedish (Sweden)",
        //     locale: "sv-SE",
        //     countryCode: "SE",
        //     countryName: "Sweden",
        //     flag: "/images/sv-SE.png",
        //     percentage: "—",
        //     stats: "—",
        // },
        // {
        //     name: "Norwegian (Norway)",
        //     locale: "nb-NO",
        //     countryCode: "NO",
        //     countryName: "Norway",
        //     flag: "/images/nb-NO.png",
        //     percentage: "—",
        //     stats: "—",
        // },
        // {
        //     name: "Danish (Denmark)",
        //     locale: "da-DK",
        //     countryCode: "DK",
        //     countryName: "Denmark",
        //     flag: "/images/da-DK.png",
        //     percentage: "—",
        //     stats: "—",
        // },
        // {
        //     name: "Finnish (Finland)",
        //     locale: "fi-FI",
        //     countryCode: "FI",
        //     countryName: "Finland",
        //     flag: "/images/fi-FI.png",
        //     percentage: "—",
        //     stats: "—",
        // },
        // {
        //     name: "Polish (Poland)",
        //     locale: "pl-PL",
        //     countryCode: "PL",
        //     countryName: "Poland",
        //     flag: "/images/pl-PL.png",
        //     percentage: "—",
        //     stats: "—",
        // },
        // {
        //     name: "Japanese (Japan)",
        //     locale: "ja-JP",
        //     countryCode: "JP",
        //     countryName: "Japan",
        //     flag: "/images/ja-JP.png",
        //     percentage: "—",
        //     stats: "—",
        // },
        // {
        //     name: "Korean (South Korea)",
        //     locale: "ko-KR",
        //     countryCode: "KR",
        //     countryName: "South Korea",
        //     flag: "/images/ko-KR.png",
        //     percentage: "—",
        //     stats: "—",
        // },
        // {
        //     name: "Chinese (China)",
        //     locale: "zh-CN",
        //     countryCode: "CN",
        //     countryName: "China",
        //     flag: "/images/zh-CN.png",
        //     percentage: "—",
        //     stats: "—",
        // },
        // {
        //     name: "English (New Zealand)",
        //     locale: "en-NZ",
        //     countryCode: "NZ",
        //     countryName: "New Zealand",
        //     flag: "/images/en-NZ.png",
        //     percentage: "—",
        //     stats: "—",
        // },
        // {
        //     name: "Hindi (India)",
        //     locale: "hi-IN",
        //     countryCode: "IN",
        //     countryName: "India",
        //     flag: "/images/hi-IN.png",
        //     percentage: "—",
        //     stats: "—",
        // },

        // {
        //     name: "English (Ireland)",
        //     locale: "en-IE",
        //     countryCode: "IE",
        //     countryName: "Ireland",
        //     flag: "/images/en-IE.png",
        //     percentage: "—",
        //     stats: "—",
        // },
    ];


    useEffect(() => {
        const fetchCountryCode = async () => {
            try {
                // const res = await axios.get('https://ipwho.is/');
                const res = await axios.get('https://ipinfo.io/json');
                const data = res?.data;
                if (data && data.country) {
                    //   setIpData(data);

                    //   setCountryCode(data.country_code.toLowerCase());
                }
            } catch (err) {
                console.error('Failed to fetch IP location:', err);
            }
        };
        fetchCountryCode();
    }, []);
    const selectedLang = languages.find((l) => l.countryCode === countryCode) || "us";

    const initAutocomplete = (el, setValue, types) => {
        if (!window.google?.maps?.places) return;
        const ac = new window.google.maps.places.Autocomplete(el, {
            types: [types],
            fields: ['address_components'],
        });
        ac.addListener('place_changed', () => {
            const place = ac.getPlace();
            (place.address_components || []).forEach((c) => {
                if (types === '(regions)' && c.types.includes('administrative_area_level_1')) {
                    setStateCode(c.short_name);
                    setStateNameFull(c.long_name); // for display

                } else if (types === '(regions)' && c.types.includes('locality')) {
                    setCityName(c.long_name);

                }
            });
        });
    };
    useEffect(() => {
        initAutocomplete(stateInputRef.current, setStateCode, '(regions)');
        initAutocomplete(cityInputRef.current, setCityName, '(regions)');
    }, []);
    useEffect(() => {
        setAgent_id(location.state?.agent?.agent_id)
        const businessDetails = location.state?.business
        const business = location.state?.agent?.business || businessDetails;
        if (business) {
            // India ka pool ek hi hai, aur Vobiz jis city se poochho usi series
            // ke number deta hai — business ki city se search karne par is screen
            // pe baaki screens se alag numbers aate the.
            const loc = numberSearchLocation({
                country: business.country_code,
                city: business.city,
                stateCode: business.state_code,
            });
            setCountryCode(loc.country);
            setStateCode(loc.stateCode);
            setCityName(loc.city);
            setStateNameFull(usesVobiz() ? '' : business.state)
        }
    }, [location]);

    // PAYG activation when redirected from Stripe checkout
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const isPayg = urlParams.get("ispayg");
        const agentIdFromUrl = urlParams.get("agentId");

        if (agentIdFromUrl) {
            setAgent_id(agentIdFromUrl);
        }

        if (isPayg === "true" && !paygActivated.current) {
            paygActivated.current = true;
            const activatePayg = async () => {
                try {
                    const response = await axios.post(
                        `${API_BASE_URL}/pay-as-you-go-saveAgent`,
                        {
                            customerId: decodeTokenData?.customerId,
                            agentId: agentIdFromUrl || agent_id,
                            status: "active",
                            isFree: true,
                            isByAdmin: false,
                            isQuickSetup: true,
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                            },
                        }
                    );

                    if (response.data.success) {
                        setPopupType("success");
                        setPopupMessage("Payment successful! Your PAYG subscription is now active.");
                        setShowPopup(true);
                        // Clean up URL params
                        window.history.replaceState({}, document.title, "/assign-number");
                    }
                } catch (error) {
                    console.error("PAYG activation error:", error.response?.data || error.message);
                    setPopupType("failed");
                    setPopupMessage("Failed to activate PAYG subscription. Please try again.");
                    setShowPopup(true);
                }
            };
            activatePayg();
        }
    }, []);

    const fetchNumbersWithFallback = async () => {
        // Single backend call — telnyxController now runs the 3-tier
        // cascade (city+state → state-only → country-only) and returns
        // `fallback_stage` so we can clear the city chip when the
        // result didn't honor the requested city. Earlier this function
        // ran its own 2-tier chain in the browser; backend cascade is
        // faster (no extra browser→server hop) and the single source
        // of truth shared with NumberAssign.
        const currentVersion = ++requestVersion.current;
        setLoading(true);
        setShowPopup(false);
        try {
            const res = await searchNumbers(token, countryCode, cityName, stateCode);
            if (requestVersion.current !== currentVersion) return;

            if (res?.success && res?.data?.length > 0) {
                setAvailableNumbers(res.data);
                // Backend stripped the city to find numbers — clear the
                // chip after a beat so the UI doesn't claim to show
                // "Irvine numbers" when they're really CA-wide.
                if (res.fallback_stage && res.fallback_stage !== "city_state") {
                    setTimeout(() => setCityName(""), 3000);
                }
            } else {
                if (!popupShownRef.current) {
                    setShowPopup(true);
                    setPopupType("failed");
                    setPopupMessage(
                        "No numbers found for the selected location. Please try a different country or state."
                    );
                    popupShownRef.current = true;
                }
                setAvailableNumbers([]);
            }
        } catch (err) {
            console.error(" Error while fetching:", err);
            if (requestVersion.current === currentVersion) {
                setAvailableNumbers([]);
            }
        } finally {
            if (requestVersion.current === currentVersion) {
                setLoading(false);
            }
        }
    };
    useEffect(() => {
        fetchNumbersWithFallback();
    }, [countryCode, cityName, stateCode]);
    const filteredNumbers = availableNumbers.filter((i) =>
        i.phone_number.includes(search.trim())
    );
    const handleRefresh = async () => {
        setIsRotating(true);
        // Generate random digit (1 to 9) as string
        const getRandomDigit = () => Math.floor(Math.random() * 9 + 1).toString();
        const startsWith = getRandomDigit();
        const endsWith = getRandomDigit();
        try {
            // First: Try with city + state + country
            const res = await searchNumbers(token, countryCode, cityName, stateCode, startsWith, endsWith);
            if (res?.success) {
                setAvailableNumbers(res.data);
            } else {
                // Fallback: Try with state + country only  
                const fallbackRes = await searchNumbers(token, countryCode, cityName, stateCode);
                if (fallbackRes?.success && fallbackRes?.data?.length > 0) {
                    setAvailableNumbers(fallbackRes.data);
                } else {
                    setAvailableNumbers([]);
                    // console.log(" No numbers found even with fallback.");
                }
            }
        } catch (error) {
            console.error(" Error in handleRefresh:", error);
            setAvailableNumbers([]);
        } finally {
            setIsRotating(false);
        }
    };
    const handleNumberClick = (num) => {
        setSelectedNumber(num);
        setModalOpen(true);
    };
    const handleBuyNumber = async () => {
        try {
            setLoading(true)
            if (numberEditMode) {
                const str = location.state?.agent?.voip_numbers
                const number = JSON.parse(str)[0];
                await deleteVoipNumber(number, agent_id)
            }
            const response = await orderNumber(selectedNumber, agent_id)
            // Carrier se number khareeda hi nahi gaya to aage mat badho —
            // assign karna aur "success" dikhana dono galat honge.
            if (response && response.success === false) {
                throw new Error(response.message || "Could not purchase the number")
            }
            await updateAgent(agent_id, {
                voip_numbers: [selectedNumber],
                voip_numbers_created: new Date(),
                assignNumFree: 1,
                isNumActivated: 1
            });

            setShowPopup(true)
            setPopupType("success")
            setPopupMessage("Number assigned successfully")

            setLoading(false)
            fetchAgentDetailsById()
            setHasFetched(false)
            setTimeout(() => {
                navigate("/fast-agent-detail")
            }, 2000);
        } catch (error) {
            console.log(error)
            // Loader band karo aur asli wajah dikhao — pehle yahan sirf log tha,
            // is liye screen chupchaap atki rehti thi.
            setLoading(false)
            setShowPopup(true)
            setPopupType("failed")
            setPopupMessage(
                error?.message || "Couldn't assign this number. Please try again."
            )
        }
    }
    useEffect(() => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            if (stateCode && countryCode) {
                fetchNumbersWithFallback();
            }
        }, 600); // Wait 600ms after the user stops typing
    }, [cityName, stateNameFull]);
    useEffect(() => {
        const selectedLangCountryCodes = languages.map((lang) => lang.countryCode);
        const isCountryValid = selectedLangCountryCodes.includes(countryCode);
        if (!isCountryValid) {
            setCountryCode(usesVobiz() ? "IN" : "US");
            setStateCode("");
            setCityName("");
            setStateNameFull("")
        }
        popupShownRef.current = false;
    }, [stateCode])
    const fetchAgentDetailsById = async () => {
        try {
            const response = await getAgentById(location.state?.agent?.agent_id);
            setVoip_numbers(response?.data?.voip_numbers)
        } catch (error) {

        }
    }
    useEffect(() => {
        fetchAgentDetailsById()
    }, [])

    return (
        <div className={styles.AssignNumberMain}>
            <div className={styles.Forsticky}>
                <HeaderBar title="Assign Phone number" bottomSubtitle="Choose your new Rexpt Phone Number" />

                <div className={styles.dropdownWrapper}>
                    <div className={styles.dropdown} onClick={() => setOpen(!open)}>
                        <img src={`https://flagcdn.com/w80/${selectedLang?.locale
                            ?.split("-")[1]
                            ?.toLowerCase()}.png`} alt={selectedLang?.label} 
                            onError={(e) => {
                                e.currentTarget.src = "https://flagcdn.com/w80/in.png"; // default India flag
                            }} 
                            className={styles.flagIcon} 
                            />
                        <span className={styles.arrow}>
                            <img src="/svg/down-arrow.svg" alt="▼" />
                        </span>
                    </div>
                    {open && (
                        <ul className={styles.dropdownMenu}>
                            {languages.map((lang) => (
                                <li key={lang.countryCode} onClick={() => {
                                    setCountryCode(lang.countryCode);
                                    setSelectedLangCode(lang.countryCode);
                                    setCityName("");
                                    setStateCode("");
                                    setStateNameFull("");
                                    setSearch("");
                                    setAvailableNumbers([]);
                                    setOpen(false);

                                    fetchNumbersWithFallback();

                                }}>
                                    <img
                                        src={`https://flagcdn.com/w80/${lang.locale
                                            ?.split("-")[1]
                                            ?.toLowerCase()}.png`}
                                        alt={lang.name}
                                        className={styles.flagIcon}
                                    />
                                    <span>{lang.countryName}</span>
                                </li>
                            ))}

                        </ul>
                    )}
                </div>
            </div>
            <div className={styles.disclaimerBox1Main}>
                <div className={styles.disclaimerBox1}>
                    <img src="/svg/important-icon.svg" alt="warning" />
                    <span>
                        <strong>Important Note: </strong> This will be the dedicated business line your customers use to call your Agent.
                    </span>
                </div>
            </div>
            <div className={styles.container}>
                {/* India ka pool ek hi hai — har city wahi Bangalore numbers
                    deti hai, to State/City poochhne ka matlab nahi. Wahi gate
                    jo ReceptionistNumber, ImmediateOwnerShip aur NumberAssign
                    pe hai; US/CA pe dono field pehle jaise hi rehte hain. */}
                {!usesVobiz() && (
                    <div className={styles.filters}>
                        <div className={styles.inputGroupSmall}>
                            <label className={styles.inputLabel}>State/Province</label>
                            <input
                                ref={stateInputRef}
                                type="text"
                                placeholder="State"
                                className={styles.inputBox}
                                value={stateNameFull}
                                onChange={(e) => setStateNameFull(e.target.value)}
                                onBlur={() => fetchNumbersWithFallback()}
                            />
                        </div>
                        <div className={styles.inputGroupLarge}>
                            <label className={styles.inputLabel}>City</label>
                            <input
                                ref={cityInputRef}
                                type="text"
                                placeholder="City"
                                className={styles.inputBox}
                                value={cityName}
                                onChange={(e) => setCityName(e.target.value)}
                                onBlur={() => fetchNumbersWithFallback()}
                            />
                        </div>
                    </div>
                )}

                <div className={styles.searchSection}>
                    <input
                        type="text"
                        placeholder="Search number for Agent"
                        className={styles.searchInput}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                    <button
                        className={`${styles.refreshBtn} ${isRotating ? styles.rotate : ''}`}
                        onClick={handleRefresh}
                    >
                        <img src="/svg/refresh-svg.svg" alt="Refresh" />
                    </button>
                </div>

                <div className={styles.numberList}>
                    {loading ? <><Loader2 /></> : filteredNumbers.length ? (
                        filteredNumbers.map((item) => (
                            <label
                                key={item.phone_number}
                                className={styles.phoneItem}
                                onClick={() => handleNumberClick(item.phone_number)}
                            >
                                <input
                                    type="radio"
                                    name="agentNumber"
                                    value={item.phone_number}
                                    checked={selectedNumber === item.phone_number}
                                    onChange={() => setSelectedNumber(item.phone_number)}
                                />
                                <span className={styles.customRadio}></span>
                                <span className={styles.numbers}>{item.phone_number}</span>
                            </label>
                        ))
                    ) : (
                        <div className={styles.noData}>No data found</div>
                    )}
                </div>

                <Modal2 isOpen={isModalOpen} onClose={() => setModalOpen(false)}>
                    <div className={styles.modalContent}>
                        <h2 className={styles.modalTitle}>Confirm Phone Number</h2>
                        {/* <p className={styles.assignText}>
                            You have chosen to <br />
                            assign{' '}
                            <span className={styles.phoneNumber}>{selectedNumber}</span> to your:
                        </p> */}
                        {numberEditMode ? <p className={styles.assignText}>
                            You already have a phone number assigned:{' '}
                            <span className={styles.phoneNumber}>
                                {/* const number = JSON.parse(str)[0]; */}

                                {JSON.parse(location.state?.agent?.voip_numbers)[0]}</span>
                            <br />
                            We will replace it with:{' '}
                            <span className={styles.phoneNumber}>{selectedNumber}</span>
                        </p> :
                            <p className={styles.assignText}>
                                You have chosen to <br />
                                assign{' '}
                                <span className={styles.phoneNumber}>{selectedNumber}</span> to your:
                            </p>}
                        <div className={styles.infoRow}>
                            <img src="/svg/green-check.svg" alt="check" />
                            <span>
                                <strong>Agent Name:</strong> {location.state?.agent?.agentName}
                            </span>
                        </div>
                        <div className={styles.infoRow}>
                            <img src="/svg/green-check.svg" alt="check" />
                            <span>
                                <strong>Business:</strong>{location.state?.agent?.business?.businessName || location.state?.business?.businessName}
                            </span>
                        </div>
                        <div className={styles.disclaimerBox}>
                            <img src="/svg/warning-svg.svg" alt="warning" />
                            <span>
                                <strong>Disclaimer:</strong> You will not be able to change this phone
                                number in current billing cycle.
                            </span>
                        </div>
                        <div className={styles.assignBtn}>
                            <AnimatedButton disabled={!numberEditMode && !!voip_numbers}
                                isLoading={loading} label="Assign Number" onClick={handleBuyNumber} position={{ position: 'relative' }} />
                            {/* <AnimatedButton disabled={!!voip_numbers}
                                isLoading={loading} label="Assign Number" onClick={handleBuyNumber} position={{ position: 'relative' }} /> */}
                        </div>
                    </div>
                </Modal2>
            </div>

            {showPopup && (
                <PopUp
                    type={popupType}
                    onClose={() => setShowPopup(false)}
                    message={popupMessage}
                    renderHTML={true}
                />
            )}
        </div>
    );
};

export default AssignNumber;
